<template lang="pug">
  .soil-sensor-chart-component(v-if="sensor")
    .chart-title
      span {{ "Records for " }}
      span <b>{{ (sensor.sensor_transmitter ? sensor.sensor_transmitter.name : "-") + " (" + (sensor.name ? sensor.name : "-") + " - " + sensor.sensor_number + handleSensorType(sensor.sensor_type) + ")" }}</b>
    .chart-wrapper
      .chart(v-if='["ee", "de", "c0", "e0", "f0", "d0", "fe"].includes(sensor.sensor_type)')
        apexchart(
          type="line"
          height="230"
          width="95%"
          :options="chartClientOptionsHumidity"
          :series="chartHumidityInfo"
          :key="chartComponentKey"
        )
      br
      .chart(v-if='["ee", "de", "c0", "e0", "f0", "d0", "fe"].includes(sensor.sensor_type)')
        apexchart(
          type="line"
          height="230"
          width="95%"
          :options="chartClientOptionsTemperature"
          :series="chartTemperatureInfo"
          :key="chartComponentKey"
        )
      br
      .chart(v-if='["ee", "e0", "f0", "fe"].includes(sensor.sensor_type)')
        apexchart(
          type="line"
          height="230"
          width="95%"
          :options="chartClientOptionsConductivity"
          :series="chartConductivityInfo"
          :key="chartComponentKey"
        )
      br
      .chart(v-if='["10", "f0", "d0", "fe"].includes(sensor.sensor_type)')
        apexchart(
          type="line"
          height="230"
          width="95%"
          :options="chartClientOptionsPh"
          :series="chartPhInfo"
          :key="chartComponentKey"
        )
      br
      .chart(v-if='["0e", "ee", "de", "fe"].includes(sensor.sensor_type)')
        apexchart(
          type="line"
          height="230"
          width="95%"
          :options="chartClientOptionsNitrogen"
          :series="chartNitrogenInfo"
          :key="chartComponentKey"
        )
      br
      .chart(v-if='["0e", "ee", "de", "fe"].includes(sensor.sensor_type)')
        apexchart(
          type="line"
          height="230"
          width="95%"
          :options="chartClientOptionsPhosphorus"
          :series="chartPhosphorusInfo"
          :key="chartComponentKey"
        )
      br
      .chart(v-if='["0e", "ee", "de", "fe"].includes(sensor.sensor_type)')
        apexchart(
          type="line"
          height="230"
          width="95%"
          :options="chartClientOptionsPotassium"
          :series="chartPotassiumInfo"
          :key="chartComponentKey"
        )
</template>

<script>

import { chartClientOptions } from "@utils/generalUtils";
import { filterUtils } from "@utils/filterUtils";
import _ from "lodash";
import VueApexCharts from "vue-apexcharts";
import { mapState } from "vuex";
import { general } from "@src/services/dynamicViews/general";

export default {
  name: "SoilSensorsCharts",
  mixins: [filterUtils, general],

  props: {
    chartData: {
      type: Array,
      default: () => [],
    },

    chartType: {
      type: String,
    },

    sensor: {
      type: Object,
    },

    fieldsInfoSettings: {
      type: Array,
      required: false,
    },
  },

  components: {
    apexchart: VueApexCharts,
  },

  data() {
    return {

      chartHumidityInfo: [
        {
          name: this.$t("sensors.chart.humidity"),
          data: [],
        },
      ],
      chartTemperatureInfo: [
        {
          name: this.$t("sensors.chart.temperature"),
          data: [],
        },
      ],
      chartConductivityInfo: [
        {
          name: this.$t("sensors.chart.conductivity"),
          data: [],
        },
      ],
      chartPhInfo: [
        {
          name: this.$t("sensors.chart.ph"),
          data: [],
        },
      ],
      chartNitrogenInfo: [
        {
          name: this.$t("sensors.chart.nitrogen"),
          data: [],
        },
      ],
      chartPhosphorusInfo: [
        {
          name: this.$t("sensors.chart.phosphorus"),
          data: [],
        },
      ],
      chartPotassiumInfo: [
        {
          name: this.$t("sensors.chart.potassium"),
          data: [],
        },
      ],

      chartComponentKey: 0,
      chartClientOptionsHumidity: chartClientOptions,
      chartClientOptionsTemperature: chartClientOptions,
      chartClientOptionsConductivity: chartClientOptions,
      chartClientOptionsPh: chartClientOptions,
      chartClientOptionsNitrogen: chartClientOptions,
      chartClientOptionsPhosphorus: chartClientOptions,
      chartClientOptionsPotassium: chartClientOptions,
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("soilSensor", ["soilSensor"]),
    
  },

  watch: {
    chartData() {
      this.mapInfosForChart();
    },
  },

  mounted() {
    this.$store.commit('soilSensor/RESET_MODULE')
  },

  methods: {
    handleSensorType(type){
      if(type)
      switch (type) {
        case '0e':
          return 'NPK';
        case 'ee':
          return 'THCNPK';
        case 'de':
          return 'THPHNPK';
        case '10':
          return 'PH';
        case 'c0':
          return 'TH';
        case 'e0':
          return 'THC';
        case 'f0':
          return 'THCPH';
        case 'd0':
          return 'THPH';
        case 'fe':
          return 'THCPHNPK';
        default:
          return 'THC';
      }
    },

    pushValueOrNull(seriesDataArray, value) {
      if (value !== null && value !== undefined) {
        if(value == 0)
          seriesDataArray.push(0.1);
        else
          seriesDataArray.push(value);
      } else {
        seriesDataArray.push(null);
      }
    },

    mapInfosForChart() {
      this.chartComponentKey += 1;

      // reset the chart
      this.chartHumidityInfo[0].data = [];
      this.chartTemperatureInfo[0].data = [];
      this.chartConductivityInfo[0].data = [];
      this.chartPhInfo[0].data = [];
      this.chartNitrogenInfo[0].data = [];
      this.chartPhosphorusInfo[0].data = [];
      this.chartPotassiumInfo[0].data = [];

      this.chartClientOptionsHumidity.xaxis.categories = [];
      this.chartClientOptionsTemperature.xaxis.categories = [];
      this.chartClientOptionsConductivity.xaxis.categories = [];
      this.chartClientOptionsPh.xaxis.categories = [];
      this.chartClientOptionsNitrogen.xaxis.categories = [];
      this.chartClientOptionsPhosphorus.xaxis.categories = [];
      this.chartClientOptionsPotassium.xaxis.categories = [];

      const mappedDays = [];
      const timeStamps = [];

      // map the transactions to match apex data

      if (this.chartData.length > 0) {
        this.chartData.forEach((info) => {
          timeStamps.push(info.created_at);
          mappedDays.push(this.buildDateTime(info.created_at, info.group_type));

          // this.chartHumidityInfo[0].data.push(info.humidity);
          this.pushValueOrNull(this.chartHumidityInfo[0].data, info.humidity)
          this.pushValueOrNull(this.chartTemperatureInfo[0].data, info.temperature)
          this.pushValueOrNull(this.chartConductivityInfo[0].data, info.conductivity)
          this.pushValueOrNull(this.chartPhInfo[0].data, info.ph)
          this.pushValueOrNull(this.chartNitrogenInfo[0].data, info.nitrogen)
          this.pushValueOrNull(this.chartPhosphorusInfo[0].data, info.phosphorus)
          this.pushValueOrNull(this.chartPotassiumInfo[0].data, info.potassium)
          // this.chartTemperatureInfo[0].data.push(info.temperature);
          // this.chartConductivityInfo[0].data.push(info.conductivity);
          // this.chartPhInfo[0].data.push(info.ph);
          // this.chartNitrogenInfo[0].data.push(info.nitrogen);
          // this.chartPhosphorusInfo[0].data.push(info.phosphorus);
          // this.chartPotassiumInfo[0].data.push(info.potassium);

        });
        this.handleHumidity(mappedDays)
        this.handleTemperature(mappedDays)
        this.handleConductivity(mappedDays)
        this.handlePh(mappedDays)
        this.handleNitrogen(mappedDays)
        this.handlePhosphorus(mappedDays)
        this.handlePotassium(mappedDays)

      }
    },

    buildDateTime(created_at, group_type){
      const localDate = new Date(created_at);
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      const hours = localDate.getHours().toString().padStart(2, '0');
      const minutes = localDate.getMinutes().toString().padStart(2, '0');
      const seconds = localDate.getSeconds().toString().padStart(2, '0');
      const day = localDate.getDate().toString().padStart(2, '0');
      // const month = (localDate.getMonth() + 1).toString().padStart(2, '0'); // JS months are 0-indexed
      const monthName = months[localDate.getMonth()];
      const year = localDate.getFullYear();

      if (group_type === "raw") {
        return localDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      }

      if (group_type === "group_by_hour") {
        // Format like: "3 AM on 14 May"
        const timeStr = localDate.toLocaleTimeString('en-US', {
          hour: 'numeric',
          hour12: true,
        });
        return `${timeStr} on ${day} ${monthName}`;
      }

      if (group_type === "group_by_day") {
        return `${day}-${monthName}-${year}`;
      }
      return `${day}-${monthName}-${year}`;
    },

    handleHumidity(mappedDays){
      const annotations = [];
      const humiditySettings = this.fieldsInfoSettings.find(
        (setting) => setting.info_type === 'humidity'
      );

      const values = this.chartHumidityInfo[0].data.filter(v => v !== null);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);

      this.chartClientOptionsHumidity = {
        ...this.chartClientOptionsHumidity,
        ...{
            xaxis: {
              categories: mappedDays,
            },
            yaxis: {
              min: minValue <= humiditySettings.range1s ? Math.round(minValue - 0.1 * minValue) : Math.round(humiditySettings.range1s - 0.1 * humiditySettings.range1s),
              max: maxValue >= humiditySettings.range1e ? Math.round(maxValue + 0.1 * maxValue) : Math.round(humiditySettings.range1e + 0.1 * humiditySettings.range1e),
              title: {
                text: this.$t("sensor_infos.um.humidity")
              },
            },
            tooltip: {
              y: {
                formatter: (val) => {
                  if (val < humiditySettings.range1s) {
                    return `↓ ${val} %RH - below min (${humiditySettings.range1s} %RH)`;
                  }
                  if (val > humiditySettings.range1e) {
                    return `↑ ${val} %RH - above max (${humiditySettings.range1e} %RH)`;
                  }
                  return `${val} %RH`;
                },
              },
            },
            annotations: {
              yaxis: [{
                y: humiditySettings.range1s,
                borderColor: '#FA8C16',
                label: {
                  borderColor: '#FA8C16',
                  style: {
                    color: '#fff',
                    background: '#FA8C16',
                  },
                  text: `Min optimal value: ${humiditySettings.range1s} %RH`,
                }
              }, 
              {
                y: humiditySettings.range1e,
                borderColor: '#FF0000',
                label: {
                  borderColor: '#FF0000',
                  style: {
                    color: '#fff',
                    background: '#FF0000',
                  },
                  text: `Max optimal value: ${humiditySettings.range1e} %RH`,
                }
              }],
            },
          },
        };
      this.chartClientOptionsHumidity.title = {text: `Humidity optimal ranges: ${humiditySettings.range1s} - ${humiditySettings.range1e} %RH`}
      this.chartClientOptionsHumidity.colors=['#73ccd8']
    },

    handleTemperature(mappedDays) {
      const temperatureSettings = this.fieldsInfoSettings.find(
        (setting) => setting.info_type === 'temperature'
      );
      const values = this.chartTemperatureInfo[0].data.filter(v => v !== null);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);

      this.chartClientOptionsTemperature = {
        ...this.chartClientOptionsTemperature,
        ...{
          xaxis: {
            categories: mappedDays,
          },
          yaxis: {
            min: minValue <= temperatureSettings.range1s ? Math.round(minValue - 0.1 * minValue) : Math.round(temperatureSettings.range1s - 0.1 * temperatureSettings.range1s),
            max: maxValue >= temperatureSettings.range1e ? Math.round(maxValue + 0.1 * maxValue) : Math.round(temperatureSettings.range1e + 0.1 * temperatureSettings.range1e),
            title: {
              text: this.$t("sensor_infos.um.temperature"),
            },
          },
          tooltip: {
            y: {
              formatter: (val) => {
                if (val < temperatureSettings.range1s) {
                  return `↓ ${val} °C - below min (${temperatureSettings.range1s} °C)`;
                }
                if (val > temperatureSettings.range1e) {
                  return `↑ ${val} °C - above max (${temperatureSettings.range1e} °C)`;
                }
                return `${val} °C`;
              },
            },
          },
          annotations: {
            yaxis: [{
              y: temperatureSettings.range1s,
              borderColor: '#FA8C16',
              label: {
                borderColor: '#FA8C16',
                style: {
                  color: '#fff',
                  background: '#FA8C16',
                },
                text: `Min optimal value: ${temperatureSettings.range1s} °C`,
              }
            }, 
            {
              y: temperatureSettings.range1e,
              borderColor: '#FF0000',
              label: {
                borderColor: '#FF0000',
                style: {
                  color: '#fff',
                  background: '#FF0000',
                },
                text: `Max optimal value: ${temperatureSettings.range1e} °C`,
              }
            }],
          }
        }
      };

      this.chartClientOptionsTemperature.title = { text: `Temperature optimal ranges: ${temperatureSettings.range1s} - ${temperatureSettings.range1e} °C`};
      this.chartClientOptionsTemperature.colors = ["#0463ca"];
    },

    handleConductivity(mappedDays){
      const conductivitySettings = this.fieldsInfoSettings.find(
        (setting) => setting.info_type === 'conductivity'
      );

      const values = this.chartConductivityInfo[0].data.filter(v => v !== null);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);

      this.chartClientOptionsConductivity = {
        ...this.chartClientOptionsConductivity,
        ...{
            xaxis: {
              categories: mappedDays,
            },
            yaxis: {
              min: minValue <= conductivitySettings.range1s ? Math.round(minValue - 0.1 * minValue) : Math.round(conductivitySettings.range1s - 0.1 * conductivitySettings.range1s),
              max: maxValue >= conductivitySettings.range1e ? Math.round(maxValue + 0.1 * maxValue) : Math.round(conductivitySettings.range1e + 0.1 * conductivitySettings.range1e),
              title: {
                text: this.$t("sensor_infos.um.conductivity")
              },
            },
            tooltip: {
              y: {
                formatter: (val) => {
                if (val < conductivitySettings.range1s) {
                  return `↓ ${val} us/cm - below min (${conductivitySettings.range1s} us/cm)`;
                }
                if (val > conductivitySettings.range1e) {
                  return `↑ ${val} us/cm - above max (${conductivitySettings.range1e} us/cm)`;
                }
                return `${val} us/cm`;
                },
              },
            },
            annotations: {
              yaxis: [{
                y: conductivitySettings.range1s,
                borderColor: '#FA8C16',
                label: {
                  borderColor: '#FA8C16',
                  style: {
                    color: '#fff',
                    background: '#FA8C16',
                  },
                  text: `Min optimal value: ${conductivitySettings.range1s} us/cm`,
                }
              }, 
              {
                y: conductivitySettings.range1e,
                borderColor: '#FF0000',
                label: {
                  borderColor: '#FF0000',
                  style: {
                    color: '#fff',
                    background: '#FF0000',
                  },
                  text: `Max optimal value: ${conductivitySettings.range1e} us/cm`,
                }
              }],
            }
          },
        };
      this.chartClientOptionsConductivity.title = {text: `Conductivity optimal ranges: ${conductivitySettings.range1s} - ${conductivitySettings.range1e} us/cm`}
      this.chartClientOptionsConductivity.colors=['#227722']
    },

    handlePh(mappedDays){
      const phSettings = this.fieldsInfoSettings.find(
        (setting) => setting.info_type === 'ph'
      );

      const values = this.chartPhInfo[0].data.filter(v => v !== null);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);

      this.chartClientOptionsPh = {
        ...this.chartClientOptionsPh,
        ...{
            xaxis: {
              categories: mappedDays,
            },
            yaxis: {
              min: minValue <= phSettings.range1s ? Math.round(minValue - 0.1 * minValue) : Math.round(phSettings.range1s - 0.1 * phSettings.range1s),
              max: maxValue >= phSettings.range1e ? Math.round(maxValue + 0.1 * maxValue) : Math.round(phSettings.range1e + 0.1 * phSettings.range1e),
              title: {
                text: this.$t("sensor_infos.um.ph")
              },
            },
            tooltip: {
              y: {
                formatter: (val) => {
                if (val < phSettings.range1s) {
                  return `↓ ${val} - below min (${phSettings.range1s})`;
                }
                if (val > phSettings.range1e) {
                  return `↑ ${val} - above max (${phSettings.range1e})`;
                }
                return `${val}`;
                },
              },
            },
            annotations: {
              yaxis: [{
                y: phSettings.range1s,
                borderColor: '#FA8C16',
                label: {
                  borderColor: '#FA8C16',
                  style: {
                    color: '#fff',
                    background: '#FA8C16',
                  },
                  text: `Min optimal value: ${phSettings.range1s}`,
                }
              }, 
              {
                y: phSettings.range1e,
                borderColor: '#FF0000',
                label: {
                  borderColor: '#FF0000',
                  style: {
                    color: '#fff',
                    background: '#FF0000',
                  },
                  text: `Max optimal value: ${phSettings.range1e}`,
                }
              }],
            }
          },
        };
      this.chartClientOptionsPh.title = {text: `Ph optimal ranges: ${phSettings.range1s} - ${phSettings.range1e}`}
      this.chartClientOptionsPh.colors=['#FFBF00']
    },

    handleNitrogen(mappedDays){
      const nitrogenSettings = this.fieldsInfoSettings.find(
        (setting) => setting.info_type === 'nitrogen'
      );

      const values = this.chartNitrogenInfo[0].data.filter(v => v !== null);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);
      
      this.chartClientOptionsNitrogen = {
        ...this.chartClientOptionsNitrogen,
        ...{
            xaxis: {
              categories: mappedDays,
            },
            yaxis: {
              min: minValue <= nitrogenSettings.range1s ? Math.round(minValue - 0.1 * minValue) : Math.round(nitrogenSettings.range1s - 0.1 * nitrogenSettings.range1s),
              max: maxValue >= nitrogenSettings.range1e ? Math.round(maxValue + 0.1 * maxValue) : Math.round(nitrogenSettings.range1e + 0.1 * nitrogenSettings.range1e),
              title: {
                text: this.$t("sensor_infos.um.nitrogen")
              },
            },
            tooltip: {
              y: {
                formatter: (val) => {
                  if (val < nitrogenSettings.range1s) {
                    return `↓ ${val} mg/kg - below min (${nitrogenSettings.range1s} mg/kg)`;
                  }
                  if (val > nitrogenSettings.range1e) {
                    return `↑ ${val} mg/kg - above max (${nitrogenSettings.range1e} mg/kg)`;
                  }
                  return `${val} mg/kg`;
                },
              },
            },
            annotations: {
              yaxis: [{
                y: nitrogenSettings.range1s,
                borderColor: '#FA8C16',
                label: {
                  borderColor: '#FA8C16',
                  style: {
                    color: '#fff',
                    background: '#FA8C16',
                  },
                  text: `Min optimal value: ${nitrogenSettings.range1s} mg/kg`,
                }
              }, 
              {
                y: nitrogenSettings.range1e,
                borderColor: '#FF0000',
                label: {
                  borderColor: '#FF0000',
                  style: {
                    color: '#fff',
                    background: '#FF0000',
                  },
                  text: `Max optimal value: ${nitrogenSettings.range1e} mg/kg`,
                }
              }],
            }
          },
        };
      this.chartClientOptionsNitrogen.title = {text: `Nitrogen optimal ranges: ${nitrogenSettings.range1s} - ${nitrogenSettings.range1e} mg/kg`}
      this.chartClientOptionsNitrogen.colors=['#A922A9']
    },

    handlePhosphorus(mappedDays){
      const phosphorusSettings = this.fieldsInfoSettings.find(
        (setting) => setting.info_type === 'phosphorus'
      );

      const values = this.chartPhosphorusInfo[0].data.filter(v => v !== null);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);
      
      this.chartClientOptionsPhosphorus = {
        ...this.chartClientOptionsPhosphorus,
        ...{
            xaxis: {
              categories: mappedDays,
            },
            yaxis: {
              min: minValue <= phosphorusSettings.range1s ? Math.round(minValue - 0.1 * minValue) : Math.round(phosphorusSettings.range1s - 0.1 * phosphorusSettings.range1s),
              max: maxValue >= phosphorusSettings.range1e ? Math.round(maxValue + 0.1 * maxValue) : Math.round(phosphorusSettings.range1e + 0.1 * phosphorusSettings.range1e),
              title: {
                text: this.$t("sensor_infos.um.phosphorus")
              },
            },
            tooltip: {
              y: {
                formatter: (val) => {
                  if (val < phosphorusSettings.range1s) {
                    return `↓ ${val} mg/kg - below min (${phosphorusSettings.range1s} mg/kg)`;
                  }
                  if (val > phosphorusSettings.range1e) {
                    return `↑ ${val} mg/kg - above max (${phosphorusSettings.range1e} mg/kg)`;
                  }
                  return `${val} mg/kg`;
                },
              },
            },
            annotations: {
               yaxis: [{
                y: phosphorusSettings.range1s,
                borderColor: '#FA8C16',
                label: {
                  borderColor: '#FA8C16',
                  style: {
                    color: '#fff',
                    background: '#FA8C16',
                  },
                  text: `Min optimal value: ${phosphorusSettings.range1s} mg/kg`,
                }
              }, 
              {
                y: phosphorusSettings.range1e,
                borderColor: '#FF0000',
                label: {
                  borderColor: '#FF0000',
                  style: {
                    color: '#fff',
                    background: '#FF0000',
                  },
                  text: `Max optimal value: ${phosphorusSettings.range1e} mg/kg`,
                }
              }],
            }
          },
        };
      this.chartClientOptionsPhosphorus.title = {text: `Phosphorus optimal ranges: ${phosphorusSettings.range1s} - ${phosphorusSettings.range1e} mg/kg`}
      this.chartClientOptionsPhosphorus.colors=['#00AA00']
    },

    handlePotassium(mappedDays){
      const annotations = [];
      const potassiumSettings = this.fieldsInfoSettings.find(
        (setting) => setting.info_type === 'potassium'
      );
      const values = this.chartPotassiumInfo[0].data.filter(v => v !== null);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);
      // this.chartPotassiumInfo[0].data.forEach((value, index) => {
      //     if (value !== null && value < potassiumSettings.range1s) {
      //       annotations.push({
      //         x: mappedDays[index],
      //         borderColor: '#FF0000',
      //         label: {
      //           borderColor: '#FF0000',
      //           style: {
      //             color: '#fff',
      //             background: '#FF0000',
      //           },
      //           text: `Low value`,
      //         },
      //       });
      //     }
      //     if (value !== null && value > potassiumSettings.range1e) {
      //       annotations.push({
      //         x: mappedDays[index],
      //         borderColor: '#FA8C16',
      //         label: {
      //           borderColor: '#FA8C16',
      //           style: {
      //             color: '#fff',
      //             background: '#FA8C16',
      //           },
      //             text: `High value`,
      //           },
      //         });
      //       }
      // });

      this.chartClientOptionsPotassium = {
        ...this.chartClientOptionsPotassium,
        ...{
            xaxis: {
              categories: mappedDays,
            },
            yaxis: {
              min: minValue <= potassiumSettings.range1s ? Math.round(minValue - 0.1 * minValue) : Math.round(potassiumSettings.range1s - 0.1 * potassiumSettings.range1s),
              max: maxValue >= potassiumSettings.range1e ? Math.round(maxValue + 0.1 * maxValue) : Math.round(potassiumSettings.range1e + 0.1 * potassiumSettings.range1e),
              title: {
                text: this.$t("sensor_infos.um.potassium")
              },
            },
            tooltip: {
              y: {
                formatter: (val) => {
                  if (val < potassiumSettings.range1s) {
                    return `↓ ${val} mg/kg - below min (${potassiumSettings.range1s} mg/kg)`;
                  }
                  if (val > potassiumSettings.range1e) {
                    return `↑ ${val} mg/kg - above max (${potassiumSettings.range1e} mg/kg)`;
                  }
                  return `${val} mg/kg`;
                },
              },
            },
            annotations: {
              // xaxis: annotations,
               yaxis: [{
                y: potassiumSettings.range1s,
                borderColor: '#FA8C16',
                label: {
                  borderColor: '#FA8C16',
                  style: {
                    color: '#fff',
                    background: '#FA8C16',
                  },
                  text: `Min optimal value: ${potassiumSettings.range1s} mg/kg`,
                }
              }, 
              {
                y: potassiumSettings.range1e,
                borderColor: '#FF0000',
                label: {
                  borderColor: '#FF0000',
                  style: {
                    color: '#fff',
                    background: '#FF0000',
                  },
                  text: `Max optimal value: ${potassiumSettings.range1e} mg/kg`,
                }
              }],
            }
          },
        };
      this.chartClientOptionsPotassium.title = {text: `Potassium optimal ranges: ${potassiumSettings.range1s} - ${potassiumSettings.range1e} mg/kg`}
      this.chartClientOptionsPotassium.colors=['#C9A0DC']
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@variables";

.settings-btn {
  border-radius: 7px !important;
  background: $tab-view-color !important;
}
</style>
